import { render } from "./PackageOrdersGeneratorTable.vue?vue&type=template&id=1bd76bca&scoped=true"
import script from "./PackageOrdersGeneratorTable.vue?vue&type=script&lang=js"
export * from "./PackageOrdersGeneratorTable.vue?vue&type=script&lang=js"

import "./PackageOrdersGeneratorTable.vue?vue&type=style&index=0&id=1bd76bca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd76bca"]])

export default __exports__